
module.exports = {
	status: 'ready',
	title: 'Banner',
	notes: '',
	context: {
		title: 'Verksamhet',
		customClass: '',
		overlap: false,
		items: [{
			title:'Rubrik 1',
			preamble: 'Helikopter 16, av tillverkaren kallad UH-60M Black Hawk, är framtagen för att möta Försvarsmaktens akuta behov av helikoptrar för att klara sjukvårds-, trupp- och materieltransporter vid nationella- och internationella insatser.',
			img:'/images/demo-soldat-1.jpg'
		},{
			title:'rubrik 2',
			preamble: 'Helikopter 16, av tillverkaren kallad UH-60M Black Hawk, är framtagen för att möta Försvarsmaktens akuta behov av helikoptrar för att klara sjukvårds-, trupp- och materieltransporter vid nationella- och internationella insatser.',
			img:'/images/demo-soldat-2.jpg'
		},{
			title:'Rubrik 3',
			preamble: 'Helikopter 16, av tillverkaren kallad UH-60M Black Hawk, är framtagen för att möta Försvarsmaktens akuta behov av helikoptrar för att klara sjukvårds-, trupp- och materieltransporter vid nationella- och internationella insatser.',
			img:'/images/demo-soldat-3.jpg'
		},{
			title:'Rubrik 4',
			preamble: 'Helikopter 16, av tillverkaren kallad UH-60M Black Hawk, är framtagen för att möta Försvarsmaktens akuta behov av helikoptrar för att klara sjukvårds-, trupp- och materieltransporter vid nationella- och internationella insatser.',
			img:'/images/demo-soldat-1.jpg'
		}],
		bgImage: '/demo-soldat-2.jpg',
		linkText: 'Aktuellt & Press',
		linkClass: '',
	}
};
